export default __webpack_public_path__ + "static/media/Farrukh_Hussain_Lodhi.681cb5f5.png";